import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

export default function Admin() {
    const [data, setData] = useState([]);
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const headers = {
        'Content-Type': 'application/json',
        'apiKey': password
    };

    const fetchData = async () => {
        if (password.length > 40 ) {
            console.error('Invalid server response');
        } else {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}/api/clientinfo`,
                    { headers }
                );
                if (response.data && typeof response.data === 'object') {
                    setData(response.data);
                } else {
                    console.error('Invalid server response');
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleNavigate = (urlDestination) => {
        navigate("/scanpage/" + urlDestination);
    };

    return (
        <div className="page">
                <label for="password">Password : </label>
                <input 
                    type="password" 
                    id="password"
                    name="password"
                    value={password}
                    onChange={handlePasswordChange}
                    placeholder="Enter your password"
                />
                <button onClick={fetchData}>
                    Envoyer
                </button>
            <p>Admin Page</p>
            {data.map((item) => (
                <p 
                    key={item._id} 
                    onClick={() => handleNavigate(item.client)}
                >
                    {item.client}
                </p>
            ))}
        </div>
    );
}